(function () {
  var nativeSubmit = HTMLFormElement.prototype.submit;
  var adding = false;

  function cartAddJsUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || form.action || '';
    return /\/cart\/add/i.test(action);
  }

  function hasKeystone(form) {
    return !!(form && form.querySelector('#key_options_block'));
  }

  function isPaymentSubmitter(submitter) {
    if (!submitter) return false;
    return !!(
      submitter.closest('.shopify-payment-button') ||
      submitter.closest('.buyinoneclick') ||
      (submitter.className && String(submitter.className).indexOf('shopify-payment-button') !== -1)
    );
  }

  function shouldIntercept(form) {
    return isCartAddForm(form) && hasKeystone(form);
  }

  function showError(err) {
    var payload = err && err.payload;
    var message =
      (payload && (payload.description || payload.message)) ||
      (err && err.message) ||
      'Unable to add this product to the cart.';
    if (typeof Shopify !== 'undefined' && typeof Shopify.onError === 'function') {
      Shopify.onError({ responseText: JSON.stringify(payload || { description: message }), status: 422 });
      return;
    }
    window.alert(message);
  }

  function refreshAndOpenRebuy() {
    function showDrawer() {
      try {
        if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
          Rebuy.SmartCart.show();
        }
      } catch (e) {}
    }

    try {
      if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchShopifyCart === 'function') {
        Rebuy.Cart.fetchShopifyCart(showDrawer);
        return;
      }
    } catch (e) {}

    showDrawer();
  }

  function addFormViaAjax(form) {
    var body = new FormData(form);
    if (body.has('return_to')) body.delete('return_to');

    return fetch(cartAddJsUrl(), {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = {};
        try {
          data = text ? JSON.parse(text) : {};
        } catch (e) {
          data = { description: text };
        }
        if (!res.ok) {
          var error = new Error(data.description || data.message || 'Add to cart failed');
          error.payload = data;
          throw error;
        }
        return data;
      });
    });
  }

  function handleAdd(form) {
    if (!form || adding) return Promise.resolve();
    adding = true;
    return addFormViaAjax(form)
      .then(function (data) {
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        } catch (e) {}
        refreshAndOpenRebuy();
        return data;
      })
      .finally(function () {
        adding = false;
      });
  }

  HTMLFormElement.prototype.submit = function () {
    if (shouldIntercept(this)) {
      handleAdd(this).catch(showError);
      return;
    }
    return nativeSubmit.apply(this, arguments);
  };

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!shouldIntercept(form)) return;
      if (isPaymentSubmitter(event.submitter)) return;
      if (event.defaultPrevented) return;

      event.preventDefault();
      handleAdd(form).catch(showError);
    },
    false
  );
})();
